import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ChipColor } from '../../../../components/pan-chip/pan-chip.component';
import { UiModule } from '../../../../components/ui.module';
import { getCaseStatusColor, getCaseStatusText } from '../../../../helpers';

@Component({
  selector: 'app-pan-grocery-ctp-status-cell',
  imports: [UiModule],
  templateUrl: './grocery-ctp-status-cell.component.html',
})
export class GroceryCtpStatusCellComponent implements ICellRendererAngularComp {
  public statusColor = signal<ChipColor>('default');
  public statusText = signal<string>('');

  agInit(params: ICellRendererParams) {
    this.updateStatus(params);
  }

  refresh(params: ICellRendererParams) {
    this.updateStatus(params);
    return true;
  }

  private updateStatus(params: ICellRendererParams) {
    const status = params.value ?? '';
    this.statusColor.set(getCaseStatusColor(status));
    this.statusText.set(getCaseStatusText(status));
  }
}
